<template>
  <div>
    <h1>Set Up Template</h1>
    <p>Use this page to set up your template. Type the text you'd like students to see. Use the symbols below to add blanks and dropdowns.</p>
    <p><b>Note: if you change your template here, you'll need to share the new URL with your students.</b></p>
    <table class="table" style="font-size:14px">
      <thead>
      <tr>
        <th>Item</th>
        <th>What to type</th>
        <th>Example</th>
        <th>Preview</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Blank</td>
        <td>Two underscores:<br><code>__</code></td>
        <td><code>The capital of MA is __</code></td>
        <td><blanks :processed="convertText('The capital of MA is __')"></blanks></td>
      </tr>
      <tr>
        <td>Blank (with default response)</td>
        <td>Two underscores with default text between them:<br><code>_default_</code></td>
        <td><code>My favorite color is _blue_</code></td>
        <td><blanks :processed="convertText('My favorite color is _blue_')"></blanks></td>
      </tr>
      <tr>
        <td>Dropdown list</td>
        <td>Square brackets (<code>[]</code>) with choices between. Use pipe (<code>|</code>) to separate choices.<br><code>[item 1|item 2]</code></td>
        <td>
          <code>I will go to my [house|school]</code>
        </td>
        <td>
          <blanks :processed="convertText('I will go to my [house|school]')"></blanks>
        </td>
      </tr>
      </tbody>
    </table>

    <ul class="nav nav-tabs">
      <li class="nav-item">
        <button class="nav-link" v-on:click="changeMode('edit',$event)" v-bind:class="{'active':mode=='edit'}" href="#">Edit template</button>
      </li>
      <li class="nav-item">
        <button class="nav-link" v-on:click="changeMode('preview',$event)" v-bind:class="{'active':mode=='preview'}" >Preview template</button>
      </li>
      <li class="nav-item">
        <button class="nav-link" v-on:click="changeMode('link',$event)" v-bind:class="{'active':mode=='link'}" href="#">Link for students</button>
      </li>
    </ul>

        <textarea @change="updateCurrentUrl" v-if="mode=='edit'" class="form-control" rows="15" v-model="inputText"></textarea>


          <blanks v-if="mode=='preview'" :processed="processed"></blanks>
    <div v-if="mode=='link'">
      Share this link with your students so they can fill out the template.
      <input type="text" readonly v-model="url" class="form-control">
      <p><b>Remember, this website does not permanently save student responses. They will need to copy and paste their responses somewhere, like into a Google Doc, to save them.</b></p>
    </div>

  </div>
</template>

<script>
  import {ConvertText, EncodeUrlComponent} from "../Functions";

  const md5 = require('md5')
  const store = require('store')
  const expirePlugin = require('store/plugins/expire')
  store.addPlugin(expirePlugin)
export default {
  name: 'Edit',
  data () {
    return {
      done:false,
      inputText: null,
      mode:'edit'
    }
  },
  computed:{
    processed(){
      return ConvertText(this.inputText)
    },
    encoded(){
      return EncodeUrlComponent(this.inputText)
    },
    url(){
      let currentPage = window.location
      return currentPage.protocol+"//"+currentPage.hostname+"/#/fill/"+this.encoded
    }
  },

  methods:{
    updateCurrentUrl(){
      const params = {};
      if(this.encoded!==''){
        params.inputText = this.encoded
      }
      this.$router.replace({
        name: 'Edit',
        params
      })
    },
    changeMode(mode, e){
      e.preventDefault
      this.mode = mode
    },
    finish(e){
      e.preventDefault()
      this.done = true
    },
    saveText(){
      const duration = 1000 * 60 * 10  //10 minute duration

      store.set('template-'+this.docId, this.processed, new Date().getTime() + duration)
    },
    loadText(){
      store.removeExpiredKeys()
      let retrieve = store.get('template-'+this.docId)
      if(retrieve !== undefined){
        this.processed = retrieve
      }
    },
    processString(){
      ConvertText(this.inputText, (result)=>{
        this.processed = result;
      })
    },
    convertText(text){
      return ConvertText(text)
    },


  },
  created: function(){
    let inputFromUrl = this.$route.params.inputText
    if(inputFromUrl !== undefined){
      this.inputText = atob(inputFromUrl)
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Edit.vue